import { useState } from "react";

import PropTypes from "prop-types";
import { Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";

import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import { FaCheckCircle } from "components/atoms/Icon/fa/FaCheckCircle";
import Image from "components/atoms/Img";
import Title from "components/atoms/Title";

const LeftContentChildren = ({ data }) => {
  return (
    <div className="mb-2 px-4 lg:mb-0 lg:px-0">
      {data.map((item, index) => {
        return (
          <div key={index} className="mt-2 flex items-start first:mt-0">
            <span>
              <FaCheckCircle
                size={16}
                className="mr-2 mt-1 text-bbc-brand-600"
              />
            </span>
            <span
              dangerouslySetInnerHTML={{ __html: item }}
              className=""
            ></span>
          </div>
        );
      })}
    </div>
  );
};

const LeftContentChildrenWithNote = ({ data }) => {
  return (
    <div className=" mb-4">
      <LeftContentChildren data={data.content} />
      {data.note && (
        <div
          className="mt-2 rounded bg-[#F1FBFF] py-2 px-4 text-sm font-normal italic text-bbc-brand-800 lg:mt-6 lg:mb-0"
          dangerouslySetInnerHTML={{ __html: data.note }}
        ></div>
      )}
    </div>
  );
};
const ListRegulation = ({ data }) => {
  return (
    <div className="grid grid-cols-2 gap-6 bg-bbc-brand-100 px-2 py-10 lg:p-6 lg:py-6">
      {data.map((service, serviceIdx) => (
        <div key={serviceIdx} className="text-center font-medium">
          <Image
            src={`/assets/icons/${service.icon}`}
            width={48}
            height={48}
            alt="icon"
            wrapper={{ className: "block flex justify-center mb-[15px] h-12" }}
          />
          <span>{service.title}</span>
        </div>
      ))}
    </div>
  );
};

const GradientEl = ({ title }) => {
  return (
    <div className="mb-3 px-4 lg:mb-6 lg:px-0">
      <span
        className=" relative bg-gradient-to-t from-[#9845E8] via-[#5b4fc4] to-[#33D2FF] bg-clip-text text-lg font-semibold text-transparent before:absolute before:bottom-0 before:left-0 before:block before:h-[1px] before:w-full 
              before:origin-top-left before:bg-gradient-to-r
              before:transition  before:content-[''] 
               lg:text-2xl "
      >
        {title}
      </span>
    </div>
  );
};
const CompanyRegistration = ({ title, contentLeft, contentRight }) => {
  return (
    <div>
      <Title
        className={
          "mb-4 px-4 text-lg font-semibold leading-9 text-bbc-brand-700 lg:mb-6 lg:px-0 lg:text-2xl"
        }
      >
        {title}
      </Title>
      <div className="lg:grid lg:grid-cols-2 lg:gap-10">
        <div>
          <GradientEl title={"Benefit"} />
          <LeftContentChildrenWithNote data={contentLeft} />
        </div>
        <div>
          <GradientEl title={"Feature"} />
          <div className="overflow-hidden rounded-xl">
            <ListRegulation data={contentRight} />
          </div>
        </div>
      </div>
    </div>
  );
};
const ButtonControlSlider = () => {
  const [touchCount, setTouchCount] = useState(0);
  const handleClickButton = () => {
    const touchPlus = touchCount + 1;

    if (touchCount % 2 === 0) {
      document
        .getElementsByClassName("company-registration-slider-button-next")[0]
        ?.click();
    } else {
      document
        .getElementsByClassName("company-registration-slider-button-prev")[0]
        ?.click();
    }
    setTouchCount(touchPlus);
  };

  return (
    <button
      className="shadow-bbc hidden h-fit w-fit rounded-full p-3 lg:inline-block"
      onClick={() => {
        handleClickButton();
      }}
    >
      <Image
        src={"/assets/icons/arrow.svg"}
        width={32}
        height={32}
        alt="arrow"
        wrapper={{
          className: `block w-full h-full pointer-events-none transition-all duration-200 ${
            touchCount % 2 === 1 ? " transform rotate-180" : ""
          }`,
        }}
      />
    </button>
  );
};
const CompanyRegistrationSlider = ({ data }) => {
  const swiper = {
    preloadImages: false,
    lazy: true,
    // Loop: true,
    allowTouchMove: false,

    navigation: {
      nextEl: ".company-registration-slider-button-next",
      prevEl: ".company-registration-slider-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 50,
  };

  return (
    <>
      <Swiper className="" modules={[Autoplay, Navigation]} {...swiper}>
        {data.data_left.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <CompanyRegistration
                key={index}
                title={data.data_right[index].title}
                contentLeft={item}
                contentRight={data.data_right[index].list_regulation}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <button className="company-registration-slider-button-next hidden"></button>
      <button className="company-registration-slider-button-prev hidden"></button>
    </>
  );
};

const OCRBelize = ({ data }) => {
  const [screen, setScreen] = useState("DESKTOP");

  useResizeScreenModified(setScreen);

  return (
    <div className="container">
      <div className="rounded-3xl lg:bg-white lg:p-10">
        <div className="mb-6 grid grid-flow-col lg:mb-2 ">
          <Title className="px-4 text-bbc-30px font-semibold text-bbc-brand-800 lg:px-0 lg:text-bbc-40px">
            {data.country}
          </Title>
          <div className="text-right">
            <ButtonControlSlider />
          </div>
        </div>
        {screen === "DESKTOP" && <CompanyRegistrationSlider data={data} />}
        <div className="block space-y-6 lg:hidden">
          {data.data_left.map((item, index) => {
            return (
              <CompanyRegistration
                key={index}
                title={data.data_right[index].title}
                contentLeft={item}
                contentRight={data.data_right[index].list_regulation}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OCRBelize;

OCRBelize.propTypes = {
  data: PropTypes.object,
  children: PropTypes.element,
};

OCRBelize.defaultProps = {
  data: {},
  children: <></>,
};
